import React from 'react';
import LoadingAnimation from './LoadingAnimation';
import profile from '../assets/aboutprofile.jpg';


class About extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({isLoading: false})
        }, 3000);
    }


    render(){
        return (
            this.state.isLoading ? <LoadingAnimation />
                :
            <div id="about">
                <div id="prof">
                    <img width="100%" src={profile} alt="Its me" />
                </div>
                <div id="abouttag" >
                    <p>About Me</p>
                </div>
                <div id="acont">
                    <p> Hello, reader. I am Himanshu Mahawar a electronics and communication engineer who loves photography more than anything in life. I started as an nature lover who is in love with the wild flora and fauna. Wildness is the thing we all love somewhere in our life. For me, my wild thinking is the thing that help me taking the photograph i want. Since, i started as a mobile photographer my photography and editing skills has improved so much which gives me the motivation for doing what i'm doing. Since then, i tried many forms of photography like street, macro (don't have a macro lens), monochrome, selective, landscape (this one, i always want to do), nature, silhouette and portraits (this is where i'm still bad at). I appreciate the raw reality of everyday life and the hidden wildness in people and nature. Apart from this, being a photographer is not only in my bucket, i do other things such than web designing and little bit of writing (thinking of improving writing skills too). My only plan of my life is to travel a lot in future and capture every journey of my mine. P.S. - Sorry for the gramatical mistakes. </p>
                </div>
            </div>
        );
    }
}


export default About;